<template>
  <div class="report-wrapper">
    <div class="filters">
      <label for="year">Yıl:</label>
      <select id="year" v-model="selectedYear" @change="getReport">
        <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
      </select>

      <label for="month">Ay:</label>
      <select id="month" v-model="selectedMonth" @change="getReport">
        <option v-for="(name, idx) in monthNames" :key="idx" :value="idx + 1">
          {{ name }}
        </option>
      </select>

    </div>

    <div v-if="loading" class="loading">Yükleniyor...</div>

    <div v-else-if="error" class="error">{{ error }}</div>

    <div v-else-if="reportData.length" class="report-result">
      <h3>{{ selectedYear }} / {{ monthNames[selectedMonth] }} Kullanım Raporu</h3>

      <table class="report-table">
        <thead>
          <tr>
            <th>Domain</th>
            <th>Müşteri</th>
            <th>Fenomen</th>
            <th>Story</th>
            <th>SMS</th>
            <th>Bio</th>
            <th>Whatsapp</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in reportData" :key="row.domain">
            <td>{{ row.domain }}</td>
            <td>{{ row.name }}</td>
            <td>{{ row.used.fenomen }}</td>
            <td>{{ row.used.story }}</td>
            <td>{{ row.used.sms }}</td>
            <td>{{ row.used.bio }}</td>
            <td>{{ row.used.whatsapp }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-else class="no-data">Seçilen dönem için veri bulunamadı.</div>
  </div>
</template>

<script>
export default {
  name: "UsageReport",
  data() {
    const now = new Date();
    return {
      selectedYear: now.getFullYear(),
      selectedMonth: now.getMonth() + 1,
      years: Array.from({ length: 5 }, (_, i) => now.getFullYear() - i),
      monthNames: [
        "Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran",
        "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"
      ],
      reportData: [],
      loading: false,
      error: null
    };
  },
  methods: {
    async getReport() {
      this.loading = true;
      this.error = null;
      try {
        const res = await this.$http.get("/manage/customers-used", {
          params: {
            year: this.selectedYear,
            month: this.selectedMonth
          }
        });

        if (res.data.success) {
          this.reportData = res.data.data;
        } else {
          this.error = res.data.error || "Bilinmeyen hata oluştu.";
          this.reportData = [];
        }
      } catch (err) {
        console.error("Rapor alınırken hata:", err);
        this.error = "Rapor alınırken bir hata oluştu.";
        this.reportData = [];
      } finally {
        this.loading = false;
      }
    }
  },
  mounted() {
    this.getReport(); // ilk yüklemede istek at
  }
};
</script>

<style scoped lang="scss">
.report-wrapper {
  padding: 1rem;

  .filters {
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
    gap: 1rem;

    label {
      font-weight: 600;
    }
    select {
      padding: 0.3rem 0.5rem;
    }
    button {
      padding: 0.4rem 0.8rem;
      cursor: pointer;
    }
  }

  .loading,
  .error,
  .no-data {
    margin-top: 1rem;
    font-weight: 600;
  }

  .error {
    color: #d33;
  }

  .report-result {
    margin-top: 1rem;

    .report-table {
      width: 100%;
      border-collapse: collapse;

      th, td {
        border: 1px solid #ddd;
        padding: 0.5rem;
        text-align: center;
      }
      th {
        background: #f0f0f0;
      }
    }
  }
}
</style>
